module.exports = __webpack_public_path__ + "static/img/pics-3.112f5d71.png";